import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'slideState';

export const getSlideShow = createAsyncThunk(
    'slideStore/getSlideShow',
    async (id, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/slideShow/${id}`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    slideShows: {},
};

const slideSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSlideShow.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getSlideShow.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.slideShows[action.meta.arg] = action.payload; 
            })
            .addCase(getSlideShow.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default slideSlice.reducer;